import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { SectionNav } from "./SectionNav";
import { sectionForPath } from "@/lib/nav";

/**
 * Routes that fill the viewport edge-to-edge instead of the boxed container.
 * Docs is here so its folder tree sits flush against this sidebar — inside the
 * boxed container the page padding opened a gap between the two nav columns.
 */
const FULL_BLEED = ["/chat", "/docs"];

export function AppLayout() {
  const { pathname } = useLocation();
  const fullBleed = FULL_BLEED.some((p) => pathname === p || pathname.startsWith(p + "/"));
  const section = sectionForPath(pathname);
  // A one-page section renders no second column — a sub-nav listing a single
  // link is chrome, not navigation.
  const sectionNav = section && section.items.length > 1 ? section : null;

  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      <Sidebar />
      {sectionNav && <SectionNav section={sectionNav} />}
      <main className={fullBleed ? "min-w-0 flex-1 overflow-hidden" : "flex-1 overflow-y-auto"}>
        {fullBleed ? (
          <Outlet />
        ) : (
          <div className="mx-auto max-w-6xl px-8 py-8">
            <Outlet />
          </div>
        )}
      </main>
    </div>
  );
}
